import React from 'react';

const Checkbox = React.forwardRef(({ className, label, ...props }, ref) => {
  return (
    <label className="flex items-center">
      <input
        ref={ref}
        type="checkbox"
        className={`form-checkbox ${className || ''}`}
        {...props}
      />
      {label && <span className="ml-2 custom-text-neutral-800">{label}</span>}
    </label>
  );
});

export default Checkbox;
